/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { Header, Button, Icon } from 'semantic-ui-react';

import Event from '../../darkmatter/Event/Event';

export default class SocialMedia extends React.PureComponent {
  getColor(colors, type) {
    if (colors === 'brand' && type) return type;
    if (colors !== 'primary' && colors !== 'secondary' && colors !== 'default') return colors;
    return null;
  }

  mapValueToButton({ link, type, label }) {
    const { colors, buttonType, showLabels, inverted, labelPosition } = this.props;
    const color = this.getColor(colors, type);

    let ButtonComponent = (
      <Button
        key={label}
        primary={colors === 'primary'}
        secondary={colors === 'secondary'}
        inverted={inverted}
        as="a"
        target="_blank"
        href={link}
        circular={buttonType === 'circle'}
        color={color}
        icon={type}
        label={label}
        labelPosition={labelPosition}
      />
    );

    if (!showLabels) {
      ButtonComponent = (
        <Button
          key={label}
          primary={colors === 'primary'}
          secondary={colors === 'secondary'}
          inverted={inverted}
          as="a"
          target="_blank"
          href={link}
          circular={buttonType === 'circle'}
          color={color}
          icon={type}
        />
      );
    }

    if (label && label !== '' && showLabels && labelPosition === 'free') {
      ButtonComponent = (
        <Button
          key={label}
          primary={colors === 'primary'}
          secondary={colors === 'secondary'}
          inverted={inverted}
          as="a"
          target="_blank"
          href={link}
          circular={buttonType === 'circle'}
          color={color}
        >
          <Icon name={type} />
          {label}
        </Button>
      );
    }

    return (
      <Event
        event={{
          category: 'Social Media',
          action: 'Click',
          label: link,
        }}
        eventType="click"
      >
        {ButtonComponent}
      </Event>
    );
  }

  renderButtonGroup() {
    const { socialMediaValues, groupButtons, groupVertically } = this.props;

    if (groupButtons) {
      return (
        <Button.Group vertical={groupVertically}>
          {socialMediaValues.map(value => this.mapValueToButton(value))}
        </Button.Group>
      );
    }

    return (
      <React.Fragment>
        {socialMediaValues.map(value => this.mapValueToButton(value))}
      </React.Fragment>
    );
  }

  render() {
    const { header } = this.props;

    return (
      <div className="fc-social-media">
        {header}
        {this.renderButtonGroup()}
      </div>
    );
  }
}

SocialMedia.propTypes = {
  socialMediaValues: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      label: PropTypes.string,
    }),
  ).isRequired,
  buttonType: PropTypes.oneOf(['rect', 'circle']),
  centerHeader: PropTypes.bool,
  colors: PropTypes.string,
  groupButtons: PropTypes.bool,
  groupVertically: PropTypes.bool,
  header: PropTypes.string,
  inverted: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['left', 'right', 'free']),
  showLabels: PropTypes.bool,
};

SocialMedia.defaultProps = {
  buttonType: 'circle',
  centerHeader: false,
  colors: 'default',
  groupButtons: false,
  groupVertically: false,
  header: '',
  inverted: false,
  labelPosition: 'free',
  showLabels: false,
};

SocialMedia.propOptions = {
  colors: ['primary', 'secondary', 'default'],
  header: ['Social Media', 'Our Social Media Addresses', ''],
};

SocialMedia.dataPropsMap = {
  socialMediaValues: ['business', 'social_media'],
};
